// Match Height js

function matchHeight(className) {
    var elements = document.querySelectorAll('.' + className);
    var rows = [];
    var currentRowTop = null;
    var currentRow = [];
    // Reset heights
    elements.forEach(function(element) {
        element.style.height = 'auto';
    });
    // Group elements by rows
    elements.forEach(function(element) {
        var rect = element.getBoundingClientRect();
        var top = rect.top;
        if (currentRowTop === null || top === currentRowTop) {
            currentRow.push(element);
            currentRowTop = top;
        } else {
            rows.push(currentRow);
            currentRow = [element];
            currentRowTop = top;
        }
    });
    rows.push(currentRow); // Push the last row
    // Apply max height to each row
    rows.forEach(function(row) {
        var maxHeight = 0;
        row.forEach(function(element) {
            var height = element.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });
        row.forEach(function(element) {
            element.style.height = maxHeight + 'px';
        });
    });
}
// Apply matchHeight on load, resize, and scroll
window.addEventListener('load', function() {
    matchHeight('product__title');
});
window.addEventListener('resize', function() {
    matchHeight('product__title');
});
window.addEventListener('scroll', function() {
    matchHeight('product__title');
});

matchHeight('product__title');